/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_History_MoreInputs */

const en_admin_ai_chat_history_more = /** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

const de_admin_ai_chat_history_more = /** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr laden`)
};

const es_admin_ai_chat_history_more = /** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar más`)
};

const fr_admin_ai_chat_history_more = /** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger plus`)
};

const nl_admin_ai_chat_history_more = /** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer laden`)
};

/** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */
const it_admin_ai_chat_history_more = en_admin_ai_chat_history_more;

/** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_history_more = en_admin_ai_chat_history_more;

/** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */
const pl_admin_ai_chat_history_more = en_admin_ai_chat_history_more;

/** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */
const hu_admin_ai_chat_history_more = en_admin_ai_chat_history_more;

/** @type {(inputs: Admin_Ai_Chat_History_MoreInputs) => LocalizedString} */
const ro_admin_ai_chat_history_more = en_admin_ai_chat_history_more;

/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Admin_Ai_Chat_History_MoreInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_history_more = /** @type {((inputs?: Admin_Ai_Chat_History_MoreInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_History_MoreInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_history_more(inputs)
	if (locale === "de") return de_admin_ai_chat_history_more(inputs)
	if (locale === "es") return es_admin_ai_chat_history_more(inputs)
	if (locale === "fr") return fr_admin_ai_chat_history_more(inputs)
	if (locale === "nl") return nl_admin_ai_chat_history_more(inputs)
	if (locale === "it") return it_admin_ai_chat_history_more(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_history_more(inputs)
	if (locale === "pl") return pl_admin_ai_chat_history_more(inputs)
	if (locale === "hu") return hu_admin_ai_chat_history_more(inputs)
	return ro_admin_ai_chat_history_more(inputs)
});
export { admin_ai_chat_history_more as "admin.ai_chat.history_more" }